import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "mapDiv",
  ref: "mapDiv",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = {
  id: "desckriptionEl",
  ref: "desckriptionEl"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: " mt-2 p-0.5 bg-yellow-500 rounded-2" }, "Simpan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, _toDisplayString($setup.selectedLocation), 1),
    _createVNode("div", _hoisted_1, null, 512),
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString($setup.selectedLocation) + " ", 1),
      _hoisted_3,
      _hoisted_4
    ], 512),
    _createVNode(_component_InputText, {
      type: "text",
      id: "pac-input",
      class: "input-primary w-full",
      modelValue: $setup.selectedLocation,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.selectedLocation = $event)),
      placeholder: "Cari Lokasi"
    }, null, 8, ["modelValue"])
  ], 64))
}